/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef, useMemo } from "react";
import axios from "axios";






const Goto = (props) => {
    const _leaveRequestID = (props.match.params.LeaveRequestID !== undefined) ? props.match.params.LeaveRequestID : null;
   
    useEffect(() => {
        axios({
            method: 'post',
            url: "/api/v1/currentdate",
            headers: { 'referpage': '/leave/request' }
        })
        .then(
            result => {

                if (_leaveRequestID != null && _leaveRequestID != '') {
                    props.history.push({
                        pathname: '/leave/request',
                        state: {
                            leaveRequestID: _leaveRequestID
                        }
                    })
                }

            },
            error => {
                props.history.push({
                    pathname: '/auth/login-page',
                    state: {
                        redirect: '/leave/id/' + _leaveRequestID
                    }
                })
            }
        );  

       


    }, [])

    return (

        <div>

       
        </div>
    );

}





export default Goto;